var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBbl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.737 5.344a1.45 1.45 0 0 0-1.474 0L6.737 8.02A1.51 1.51 0 0 0 6 9.326v5.348c0 .54.283 1.037.737 1.308l4.526 2.674c.454.27 1.02.27 1.474 0l4.526-2.674A1.51 1.51 0 0 0 18 14.674V9.326a1.52 1.52 0 0 0-.737-1.307zm-.557.695a.27.27 0 0 0-.274 0L7.037 8.897a.28.28 0 0 0-.137.24v5.726c0 .098.051.189.137.24l4.869 2.859a.26.26 0 0 0 .274 0l4.869-2.86a.28.28 0 0 0 .137-.24V9.138a.28.28 0 0 0-.137-.24L12.18 6.043zm.399.557a1.1 1.1 0 0 0-1.158 0L7.865 8.764c-.36.219-.578.51-.578.948v4.902c0 .33.128.39.343.493c.068.035.145.073.235.129l3.558 2.173c.36.214.797.214 1.157 0l3.557-2.173c.085-.056.171-.095.24-.129c.214-.103.338-.163.338-.493V9.712c0-.438-.218-.73-.578-.943L12.58 6.592zm-.463.278a.22.22 0 0 0-.232 0L7.83 9.334a.24.24 0 0 0-.116.206v4.92c0 .086.043.163.116.206l4.054 2.46a.22.22 0 0 0 .232 0l4.054-2.46a.24.24 0 0 0 .116-.206V9.54a.24.24 0 0 0-.116-.206zm2.764 3.858l-2.666 1.542v3.108c0 .128-.107.24-.24.24c-.128 0-.188-.108-.188-.24v-3.108l-2.67-1.542a.24.24 0 0 1 .057-.437a.23.23 0 0 1 .178.025l2.628 1.543l2.67-1.543a.23.23 0 0 1 .321.086a.24.24 0 0 1-.086.325z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbl);
export default __webpack_public_path__ + "static/media/bbl.7ed2258ed0529b85fc4c702814f08471.svg";
export { ForwardRef as ReactComponent };